import React, { useEffect, useRef, useState } from "react";
import Main from "./components/Main";
import ContactForm from "./components/ContactForm";
import Header from "./components/Header";
import PopupForm from "./components/PopupForm";

const App = () => {
  const contactRef = useRef(null);
  const [showPopup, setShowPopup] = useState(false);
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowPopup(true);
    }, 8000);
    return () => clearTimeout(timer);
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const scrollToContact = () => {
    if (contactRef.current) {
      const yOffset = 250;
      const y =
        contactRef.current.getBoundingClientRect().top +
        window.pageYOffset +
        yOffset;

      window.scrollTo({ top: y, behavior: "smooth" });
    }
  };

  return (
    <>
      <Header scrollToContact={scrollToContact} />
      <Main scrollToContact={scrollToContact} />
      <div ref={contactRef}>
        <ContactForm />
      </div>
      {showPopup && <PopupForm onClose={handleClosePopup} />}
    </>
  );
};

export default App;
